var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC9l\\xE9ments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icones/Action/Upload/Fill/Blanc",
    className: "st0-fill",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.292,20.7061 C11.385,20.7991 11.495,20.8721 11.618,20.9231 C11.74,20.9741 11.87,21.0001 12,21.0001 C12.13,21.0001 12.26,20.9741 12.382,20.9231 C12.505,20.8721 12.615,20.7991 12.708,20.7061 L15.707,17.7071 C16.098,17.3161 16.098,16.6841 15.707,16.2931 C15.316,15.9021 14.684,15.9021 14.293,16.2931 L13,17.5861 L13,8.0001 C13,7.4481 12.553,7.0001 12,7.0001 C11.447,7.0001 11,7.4481 11,8.0001 L11,17.5861 L9.707,16.2931 C9.316,15.9021 8.684,15.9021 8.293,16.2931 C7.902,16.6841 7.902,17.3161 8.293,17.7071 L11.292,20.7061 Z",
    id: "Fill-1",
    transform: "translate(12.000000, 14.000100) scale(1, -1) translate(-12.000000, -14.000100) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,3 L6,3 C5.447,3 5,3.448 5,4 C5,4.552 5.447,5 6,5 L18,5 C18.553,5 19,4.552 19,4 C19,3.448 18.553,3 18,3",
    id: "Fill-3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadWhite);
export default __webpack_public_path__ + "static/media/upload_white.1ce4d40aa978d086ebd05471ee48f08f.svg";
export { ForwardRef as ReactComponent };